/**
 * LandingLiveDotLarge
 * -------------------
 * A reusable pulsing green dot used to indicate live/active status on the landing
 * page (e.g. Bracketeers count, section headings). Sizing is kept at 1.25rem (w-5 / h-5)
 * to match existing design, and we include an `animate-ping` halo for subtle motion.
 */
type Props = {
  /** Additional Tailwind classes */
  className?: string
}

// Renders the static green "live" dot used across landing sections.
// Matches exactly the original design used next to the Bracketeers count
// (no halo / ping animation).
export function LandingLiveDotLarge({ className = "" }: Props) {
  return (
    <span
      className={`inline-block w-5 h-5 rounded-full bg-[#22FF65] shadow-[0_0_3px_#22FF65BD,0_0_8px_#22FF65BD,0_0_15px_#22FF65BD] ${className}`.trim()}
    />
  )
}
